/*=========================================================================================
  File Name: moduleSpaceMutations.js
  Description: Space Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  CREATE_STUDENTNOTICE(state, payload) {
    state.studentNotices.unshift(payload)
  },
  UPDATE_STUDENTNOTICE(state, payload) {
    var index = state.studentNotices.findIndex(function(item){return item.id == payload.id})
    if (index != -1){
      Object.assign(state.studentNotices[index], payload)
      state.ActiveStudentNotice = state.studentNotices[index]
    }
  },
  DELETE_STUDENTNOTICE(state, payload) {
    var index = state.studentNotices.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.studentNotices.splice(index,1)
    }
  },
  SET_ACTIVE_STUDENTNOTICE(state, payload) {
    state.ActiveStudentNotice = payload
  },
  SET_STUDENTNOTICE_LIST(state, payload){
    state.studentNotices = payload
    // state.ActiveStudentNotice = state.studentNotices[0]
  },
  SET_STUDENTNOTICE_SEARCH_QUERY(state, query) {
      state.studentNoticeSearchQuery = query
  },
  CREATE_STUDENTNOTICE_COMMENT(state, payload){
    state.studentNoticeComments.push(payload)

  },
  SET_STUDENTNOTICE_COMMENT_LIST(state, payload){
    state.studentNoticeComments = payload
    // state.ActiveStudentNotice = state.studentNotices[0]
  },
  UPDATE_STUDENTNOTICE_COMMENT(state, payload) {
    var index = state.studentNoticeComments.findIndex(function(item){return item.id == payload.id})
    if (index != -1){
      Object.assign(state.studentNoticeComments[index], payload)
    }
  },
  DELETE_STUDENTNOTICE_COMMENT(state, payload) {
    var index = state.studentNoticeComments.findIndex(function(item){return item.id == payload})
    if(index != -1){
      state.studentNoticeComments.splice(index,1)
    }
  },
}
